import { FeatureHeaderLink } from '../components/Header/Header';
import { UserPreferences } from '../slices/userPreferences/userPreferencesSlice';

declare type FeatureGroup = {
  [featureName: string]: boolean | FeatureGroup;
};

export const featureFilter = (
  link: FeatureHeaderLink,
  features: FeatureGroup,
  userPreferences: UserPreferences | undefined
): boolean => {
  // disable if the link contains enableOnUserPreferences but userPreferences is not loaded yet
  if (
    link.enableOnUserPreferences !== undefined &&
    userPreferences === undefined
  ) {
    return false;
  }
  // user preferences part
  if (
    userPreferences !== undefined &&
    link.enableOnUserPreferences !== undefined
  ) {
    const userPreferenceStatus = userPreferences[link.enableOnUserPreferences];
    if (
      userPreferenceStatus !== undefined &&
      userPreferenceStatus.toLowerCase() === 'false'
    ) {
      return false;
    }
  }
  // feature flags part
  if (link.disableOnFeature) {
    return features[link.disableOnFeature] !== true;
  }
  if (link.enableOnFeature) {
    return features[link.enableOnFeature] === true;
  }

  return true;
};
